import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Film Excerpt",
  tags: ["film-text"],
  icon: "format-aside",
  description: "The excerpt of the film, imported from Ferve.",
  category: "Film",
  conditions: {
    multiple: false,
  },
}

export default defineBlock("film/film-short-description", (props) => {
  return (
    <div className="film-short-description flex flex-col gap-2 mb-4">
      {/* <EditableText
        as="p"
        className="type-label-caps text-grey"
        store="short-desc-title"
        placeholder="Synopsis"
        defaultValue="Synopsis"
      /> */}
      <div
        className="type-body-l wysiwyg [&_p]:max-w-none"
        dangerouslySetInnerHTML={{ __html: props.film?.descriptions?.short ?? "" }}
      />
    </div>
  )
})
